import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Package } from '@stone/interfaces';

interface PackagesState {
  pending: Package[];
  recent: Package[];
  loading: boolean;
  error: string | null;
}

const initialState: PackagesState = {
  pending: [],
  recent: [],
  loading: false,
  error: null,
};

const packagesSlice = createSlice({
  name: 'stone.packages',
  initialState,
  reducers: {
    fetchPackagesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchPackagesSuccess: (state, action: PayloadAction<{ pending: Package[]; recent: Package[] }>) => {
      state.pending = action.payload.pending;
      state.recent = action.payload.recent;
      state.loading = false;
    },
    fetchPackagesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchPackagesRequest, fetchPackagesSuccess, fetchPackagesFailure } = packagesSlice.actions;
export default packagesSlice.reducer;
